import React, {Component} from 'react';
import {connect} from "react-redux";
import * as VideoActions from '../../../store/actions/videoActions';
import moment from 'moment';
import {NotificationManager} from 'react-notifications';

/* global $ */

class DeadlineModal extends Component {


    constructor(props){
        super(props);

        this.state = {
            confirmSubjectDateModal: false,
            subjectDate: null,
            dateRowEdit: false,
        }
    }

    componentDidMount(){
        this.buildCalendar();
    }

    componentDidUpdate(props, state){
        if(state.subjectDate !== this.state.subjectDate){
            this.buildCalendar();
        }else if(!this.state.subjectDate && this.props.course){
            let subject = this.props.course.CourseSubject.filter(s => s.id === this.props.courseUser[0].currentSubject);
            if(subject.length > 0){
                subject = subject[0];
                this.setState({subjectDate: "sdsds_" + moment().add(parseInt(subject.duration) - 1, 'days').format('YYYY-MM-DD')});
                
            }
        }

        if(!state.dateRowEdit && this.state.dateRowEdit){
            if(this.props.courseUser[0].id){
                let subject = this.props.course.CourseSubject.filter(s => s.id === this.props.courseUser[0].currentSubject);
                if(subject.length > 0){
                    subject = subject[0];
                    $('#subjectDeadlineText').attr("class","").html(`Your score guarantee is based on the recommended time for this subject, which is ${subject.duration} days. Changing your subject deadline, or not completing your tasks in the given time, will affect your score guarantee. It is recommended that once you set your ${subject.name} Subject Deadline for ${subject.duration} days, you do not miss it, so that your score guarantee remains intact.`);
                    $('#subjectDeadlineText').addClass("subjectDeadlineText animated bounceInUp bg-red");
                }
            }
            
        
        }else if(state.dateRowEdit && !this.state.dateRowEdit){

        }
    }

    resetToDefault = () => {
        let subject = this.props.course.CourseSubject.filter(s => s.id === this.props.courseUser[0].currentSubject);
        if(subject.length > 0){
            subject = subject[0];
            this.setState({subjectDate: "sdsds_" + moment().add(parseInt(subject.duration) - 1, 'days').format('YYYY-MM-DD'), dateRowEdit: false});
            
        }
    }

    buildCalendar = () => {
        let {courseUser, course} = this.props;
        if(!courseUser || courseUser.filter(cu => cu.id).length === 0){
            return null;
        }

        if(!this.state.subjectDate){
            return null;
        }

        const cu = courseUser[0];
        
        let data = [];
        let self = this;
        // Get last End Date or today:
        let beginRemaining;

        let lastSubject = (this.props.us.filter(s => s.completed).length > 0) ? this.props.us.filter(s => s.completed)[this.props.us.filter(s => s.completed).length - 1] : null;
        let lastEndDate = (lastSubject) ? moment(lastSubject.completedOn) : moment();
        cu.subjectOrder.map((so, i) => {
            let subject = course.CourseSubject.filter(s => s.id === so)[0];
            let dateRange = '';
            if(subject){
                if(subject.id === cu.currentSubject){
                    let current = moment();
                    
                    let subjectDateSplit = (this.state.subjectDate) ? this.state.subjectDate.split('_') : moment();
                    let end = moment(subjectDateSplit[subjectDateSplit.length - 1]);
                    lastEndDate = end;
                    
                    while(end.diff(current, 'days') >= 0){
                        let newDate = current.format('YYYY-MM-DD');
                        let d = {date: newDate, classname: 'bg-sub-' + i};
                            data.push(d);
                            current.add(1, 'days');
                    }
                    lastEndDate.add(1, 'days');
                }else if(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).length === 0){
                    // Not completed yet, future course
                    let lastEnd = moment(this.state.subjectDate.split('_')[1]);
                    let courseEnd = moment(cu.testDate);
                    let subjectsCompleted = this.props.us.filter(s => s.completed && s.active).length;
                    let subjectsToComplete = cu.subjectOrder.length;
    
                    let subjectsRemaining = subjectsToComplete - subjectsCompleted;
                    let currentSubjectIndex = cu.subjectOrder.indexOf(cu.currentSubject);
                    if(i > currentSubjectIndex){
                        // After current subject;
                        let current = moment(lastEndDate.format('YYYY-MM-DD'));
                        let end = moment(lastEndDate.format('YYYY-MM-DD')).add(subject.duration - 1, 'days');
                        
                        while(end.diff(current, 'days') >= 0){
                            let newDate = current.format('YYYY-MM-DD');
                            let d = {date: newDate, classname: 'bg-sub-' + i};
                             data.push(d);
                             current.add(1, 'days');
                        }
                        
                        dateRange = lastEndDate.add(subject.duration, 'days');
    
                    }
                }
            }
        });

        let testDate = moment(this.props.courseUser[0].testDate).format('YYYY-MM-DD');
        if(data.filter(d => d.date === testDate).length > 0 && this.props.courseUser[0].testDate){
            let subject = {};
            if(this.props.courseUser[0].currentSubject){
                subject = this.props.course.CourseSubject.filter(s => s.id === this.props.courseUser[0].currentSubject)[0];
            }
            
            NotificationManager.error('You would not meet your test date with this timeline.');
            this.setState({subjectDate: "sdsds_" + moment().add(parseInt(subject.duration) - 1, 'days').format('YYYY-MM-DD')});
        }
        
        if(cu.testDate){
            data.push({date: moment(cu.testDate).format('YYYY-MM-DD'), classname: 'day-selected-for-test'});
        }
        
        $('.subjectDeadlineContainer').html('<div id="deadline_calendar"></div>');
        $("#deadline_calendar").empty();
        $("#deadline_calendar").zabuto_calendar({
            language: "en",
            cell_border: false,
            month: (this.state.subjectDate) ? parseInt(moment(this.state.subjectDate.split('_')[this.state.subjectDate.split('_').length - 1]).format('MM')) : new Date().getMonth() + 1,
            action: function(e){
                let d = "sdsdsd_" + this.id.split(/(.+)_/)[2];
                return self.setState({subjectDate: d});
            },
            data: data
        });
        

    
    }

    renderOptionRange = (m, count) => {
        let data = [];

        while(m.diff(moment(), 'days') < 30){
            m = m.add(1, 'days');
            data.push({
                val: "sdsds_" + m.format('YYYY-MM-DD'),
                label: m.format('DD MMM')
            })
        }

        return data.map((d, i) => {
            return <option value={d.val}>{d.label}</option>
        })
    }

    renderSubject = (subject, index) => {
        let currentSub = false;
        let lastEndDate = null;
        if(this.props.courseUser[0].id){
            if(this.props.courseUser[0].currentSubject === subject.id){
                currentSub = true;
            }
        }

        if(!this.state.subjectDate){
            return null;
        }

        let dateRange = '';
     
        if(subject.id === this.props.courseUser[0].currentSubject){
            // Current subject, use today until subject end date
            let start = moment();
            
            
            
            let subjectDateSplit = this.state.subjectDate.split('_')
            let end = moment(subjectDateSplit[subjectDateSplit.length - 1]);
            lastEndDate = end;

            dateRange = start.format('MMM DD') + ' - ' + end.format('MMM DD');
        }else if(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).length === 0){
            
            // Not completed yet, future course
            // Use previous end date as start, and date + duration as end
            let lastEnd = moment(this.state.subjectDate.split('_')[1]);
            let courseEnd = moment(this.props.courseUser[0].testDate);
            let subjectsCompleted = this.props.us.filter(s => s.completed && s.active).length;
            let subjectsToComplete = this.props.courseUser[0].subjectOrder.length;

            let subjectsRemaining = subjectsToComplete - subjectsCompleted;
            let currentSubjectIndex = this.props.courseUser[0].subjectOrder.indexOf(this.props.courseUser[0].currentSubject);
            if(index > currentSubjectIndex){
                if(index - 1 === currentSubjectIndex){
                    lastEndDate = moment(lastEnd);
                }else{
                    lastEndDate = moment(lastEnd);
                    this.props.courseUser[0].subjectOrder.map((so, si) => {
                        let subject = this.props.course.CourseSubject.filter(s => s.id === so);
                        if(subject.length > 0){
                            subject = subject[0];
                            if(si < index && so !== this.props.courseUser[0].currentSubject){
                                lastEndDate.add(subject.duration, 'days');
                            }
                        }
                        
                    })
                }
                // After current subject;
                try{
                    dateRange = lastEndDate.add(1, 'days').format('MMM DD') + ' - ' + lastEndDate.add(subject.duration - 1, 'days').format('MMM DD');
                }catch(err){
                }

            }
        }else if(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).length > 0){
            dateRange = moment(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id)[0].subjectStarted).format('MMM DD') + ' - ' + moment(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id)[0].completedOn).format('MMM DD')
        }

        return (
            <div className="studyPlan" data-subject='physics' onMouseEnter={e => {
                if(!this.state.dateRowEdit){
                    $(".day").css("opacity","0.2");
                    $(".bg-sub-"+index).css("opacity","1");
                    var h = $(this).attr("data-desc");
                    if(subject.id === this.props.courseUser[0].currentSubject){
                        $("#subjectDeadlineText").html(`${subject.name} timeline. Click on the highlighted calendar button to personalize.`).slideDown();
                    }else{
                        $("#subjectDeadlineText").html(`${subject.name} timeline. This can't be edited until you are studying for this subject.`).slideDown();
                    }
        
                    $('#subjectDeadlineText').attr("class","");
                    $('#subjectDeadlineText').addClass("subjectDeadlineText color-sub-"+index);
                }
            }} onMouseLeave={e => {
                if(!this.state.dateRowEdit){
                    $(".day").css("opacity","1");
                    $("#subjectDeadlineText").html('');
                }
            }} data-desc=''>
                <div className={`studyPlanIcon bg-sub-${index}`}>{subject.name[0]}</div>
                <div className="studyPlanDesc">
                    <h4>{subject.type === 'review' ? 'Days to Review' : subject.name}</h4>
                    <div className={`studyPlanDates ${this.state.dateRowEdit && currentSub ? 'hidden' : ''}`}>
                        <div className="row">
                            <div className="col-xs-8">
                                <p>{subject.type === 'review' ? subject.duration ? subject.duration + ' days' : '1 day' : dateRange}</p>
                            </div>
                            {currentSub ?
                            <div className="col-xs-4">
                                <div className="text-right">
                                    <a href="#" className="changeDeadLineDateBtn" onClick={e => this.setState({dateRowEdit: true})}><i className="zmdi zmdi-calendar"></i> </a>
                                </div>
                            </div>
                            : null}
                        </div>
                    </div>

                    <div className={`studyPlanDatesForm ${this.state.dateRowEdit && currentSub ? '' : 'hidden'}`}>
                        <div className="row">
                            <div className="col-xs-8">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <select className="form-control" disabled={true}>
                                            {
                                                this.renderOptionRange(moment().subtract(1, 'days'), 30)
                                            }
                                            
                                        </select>
                                    </div>
                                    <div className="col-sm-6">
                                        <select className="form-control" value={this.state.subjectDate} onChange={e => {
                                            this.setState({subjectDate: e.target.value})
                                        }}>
                                        {
                                            this.renderOptionRange(moment().add(subject.duration - 1, 'days'), 30)
                                        }
                                    </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-4">
                                <div className="text-right">
                                    <a href="#" className="btn btn-success" onClick={e => this.props.onSelect(this.state.subjectDate)}><i className="fa fa-check"></i> </a>
                                    <a href="#" className="CloseDeadLineDateBtn btn btn-default" onClick={e => this.resetToDefault()}><i className="zmdi zmdi-close"></i> </a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render(){
        let {courseUser, course} = this.props;

        if(!courseUser || courseUser.filter(cu => cu.id).length === 0){
            return null;
        }

        const cu = courseUser[0];
        const subject = course.CourseSubject.filter(s => s.id === cu.currentSubject)[0];

        if(!subject){
            return null;
        }
        
        return (
            <div className="modal fade" id="SetDeadLineModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-body no-padding">
                            <div className="clearfix">
                                <div style={{width: 550}} className="pull-left overflow-hidden">
                                    <div className="modal-header">
                                        <h4 className="modal-title" id="myModalLabel">Set a Deadline for {subject.name}</h4>
                                    </div>
                                    <div className="subjectDeadlineContainer"><div id="SetSubjectDeadlineCalendar" style={{height: 300}}></div></div>
                                    
                                    <div className="sp-20 subjectDeadlineText" id='subjectDeadlineText'>
                                        <p className="sm-bottom0">Your score is guaranteed based on your the suggested deadlines. If you set the deadline and are unable to meet finish work by the expected timeline, this will affect your score guarantee. </p>
                                    </div>
                                </div>
                                <div className="pull-right">
                                    <div className="studyPlanWrapper">
                                        <div className="modal-header">
                                            <h4 className="modal-title" id="myModalLabel">Study Plan</h4>
                                        </div>
                                        <div className="studyPlans"  style={{height: 400, overflowY: 'auto', overflowX: 'hidden'}}>
                                            {cu.subjectOrder.map((sub, i) => {
                                                let subject = course.CourseSubject.filter(s => s.id === sub);
                                                if(subject.length === 0){
                                                    return null;
                                                }else{
                                                    subject = subject[0];
                                                    return this.renderSubject(subject, i);
                                                }
                                            })}
                                            
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-default" onClick={e => this.resetToDefault()}>Reset To Defaults</button>
                            <button type="button" className="btn btn-danger" onClick={e => this.props.onSelect(this.state.subjectDate)}>Set Deadline</button>
                        </div>
                    </div>
                </div>

            </div>
           
        )
    }
}



const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    updateCourseUser: (cu, pid, token) => {
        dispatch(VideoActions.updateCourseUser(cu, pid, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeadlineModal);


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardUser/DeadlineModal.js